module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.28.0-f3d742a11.svg#wishlist-v2-filled-large","viewBox":"0 -0.6 26.5 26"}